import { useStateParams } from '../../../../hooks/use-state-params';
import { CUSTOMERS_QUERY_SEARCH_PARAM_KEY } from './use-query-input-param-consts';

export function useQueryInputParams() {
  return useStateParams<string | undefined>(
    undefined,
    CUSTOMERS_QUERY_SEARCH_PARAM_KEY,
    (query) => query,
    (query) => query ?? undefined,
  );
}
